define.alias("shared/components/shared/post/secondary/toggle", "media/components/shared/post/secondary/toggle");